<template>
  <v-form v-model="valid" ref="mainForm">
    <opq-case
      code="declaration-changement"
      v-model="sasReconnaissanceDeFormation.engagementInformerOrdreChangement"
      :live="liveSasReconnaissanceFormation(10738)"
    >
    </opq-case>

    <opq-case code="declaration-exact" v-model="sasReconnaissanceDeFormation.informationsExactes" :live="liveSasReconnaissanceFormation(10739)">
    </opq-case>

    <opq-case
      code="declaration-contenu"
      v-model="sasReconnaissanceDeFormation.engagementFournirContenu"
      :live="liveSasReconnaissanceFormation(10740)"
    >
    </opq-case>
  </v-form>
</template>

<script>
import FormSimple from "@/mixins/FormSimple"
export default {
  mixins: [FormSimple],
  props: {
    sas: { type: Object }
  },

  computed: {
    sasReconnaissanceDeFormation() {
      return this.sas.sasReconnaissanceDeFormation
    }
  },

  methods: {
    liveSasReconnaissanceFormation(cle) {
      return { endpoint: "/sas-reconnaissance-formation/", cle: cle, fileId: this.sasReconnaissanceDeFormation.id }
    }
  }
}
</script>

<style>
</style>